<template>
  <div>
    <form class="ui form" id="filter">
      <div class="two fields">
        <div class="field">
          <label>Группа документов</label>
          <select id="doc_basic_kind" class="ui search selection dropdown" name="doc_basic_kind" v-model="doc_basic_kind" v-on:change="LoadDocType()">
            <option v-for="option in options_doc_basic_kind" :value="option.id" :key="option.id">
              {{ option.text }}
            </option>
          </select>
        </div>
        <div class="field">
          <label>Год документа</label>
          <select id="doc_year" class="ui search selection dropdown" name="doc_year" v-model="doc_year">
            <option v-for="option in options_years" :value="option.text" :key="option.id">
              {{ option.text }}
            </option>
          </select>
        </div>
        <div class="ui icon button" style="margin-top:24px;" v-on:click="ClearDocYear()">
          <i class="trash icon"></i>
        </div>
      </div>
      <div class="two fields">
        <div class="field">
          <label>Типы документов</label>
          <select id="doc_type" class="ui search selection dropdown" name="doc_type" v-model="doc_type" v-on:change="LoadDocKind()">
            <option v-for="option in options_doc_type" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="field">
          <label>Образовательная программа</label>
          <div class="ui fluid search selection dropdown">
            <input type="hidden" id="educational_programm" name="educational_programm" v-on:change="SetEducationalProgramm($event.target.value)">
            <i class="dropdown icon"></i>
            <div id="default_educational_programm" class="default text"></div>
            <div class="menu">
              <div class="item" v-for="option in options_educational_programm" :data-value="option.id" :key="option.id">{{ option.speciality_name }}</div>
            </div>
          </div>
        </div>
        <div class="ui icon button" style="margin-top:24px;" v-on:click="ClearEducationalProgramm()">
          <i class="trash icon"></i>
        </div>
      </div>
      <div class="two fields">
        <div class="field">
          <label>Виды документов</label>
          <select id="doc_kind" class="ui search selection dropdown" name="doc_kind" v-model="doc_kind">
            <option v-for="option in options_doc_kind" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="field">
          <label>Дата создания</label>
          <input id="doc_date_create" type="date" name="doc_date_create" v-model="doc_date_create">
        </div>
        <div class="ui icon button" style="margin-top:24px;" v-on:click="ClearDocDateCreate()">
          <i class="trash icon"></i>
        </div>
      </div>
      <div class="field">
        <label>Сертификаты</label>
        <select id="CertListBox" class="ui search selection dropdown" name="doc_basic_kind" v-model="certificate">
          <option v-for="option in options_certificates" :value="option.thumb_print" :key="option.thumb_print">
            {{ option.sub_name }}
          </option>
        </select>
      </div>
    </form>
    <div class="ui error message" v-if="error_message_flag">
      <i class="close icon"></i>
      <div class="header">
        Ошибка
      </div>
      {{error_message_text}}
    </div>
    <div class="ui segment">
      <div class="ui top blue attached progress" id="progress_bar" v-if="progress_bar_flag">
        <div class="bar"></div>
      </div>
      <table class="ui celled table">
        <thead>
        <tr>
          <th style="width:50px">
            <div class="ui fitted slider checkbox">
              <input type="checkbox" v-model="checked" v-on:change="SetAllChecked"> <label></label>
            </div>
          </th>
          <th>Файл</th>
          <th>Подпись</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="file in options_doc_file" :key="file.id" :class="file.status">
            <td class="collapsing">
              <div class="ui fitted slider checkbox">
                <input type="checkbox" :value="file" v-model="signature_checked" :disabled="file.url == ''"><label></label>
              </div>
            </td>
            <td v-if="file.type_save_file=='fs'">
                <a :href="url.origin + file.url" target="_blank" :class="file.url == '' ? 'disabled_text' : ''"  :data-tooltip="file.url.match(/[A-Za-z0-9_\\.-]*.pdf/)" data-position="top left" data-inverted="" >{{ file.name }}</a>
            </td>
            <td v-else-if="file.type_save_file=='ad'">
              <a :href="file.url" target="_blank" :class="file.url == '' ? 'disabled_text' : ''">{{ file.name }}</a>
            </td>
            <td v-if="file.type_save_file=='fs'">
              <a :href="file.url_sig" v-if="file.url_sig" target="_blank" data-inverted="" :data-tooltip="file.url_sig.match(/[A-Za-z0-9_\\.-]*.sig/)" data-position="top right" >Подпись</a>
            </td>
            <td v-else-if="file.type_save_file=='ad'">
                <a :href="file.url_sig" v-if="file.url_sig" target="_blank">Подпись</a>
            </td>
          </tr>
        </tbody>
        <tfoot class="full-width">
        <tr>
          <th></th>
          <th colspan="4">
            <div class="ui right floated small primary labeled icon button" v-on:click="SetSignature()">
              <i class="pencil alternate icon"></i> Подписать
            </div>
            <div class="ui small button" v-on:click="DeleteSignature('object')">
              Удалить
            </div>
            <div class="ui small  button" v-on:click="DeleteSignature('sig')">
              Удалить подпись
            </div>
            <div class="ui small  button" v-on:click="CheckSignature()">
              Проверить подпись
            </div>
          </th>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash';

export default {
  name: "digital_signature",
  data: () => ({
    checked: false,
    url: window.location,
    progress_bar_flag: false,
    error_message_flag: false,
    error_message_text: "",

    conte_enable_file: 0,
    educational_programm: "",
    doc_basic_kind: "",
    doc_type: "",
    doc_kind: "",
    doc_year: "",
    doc_date_create: "",
    certificate: "",
    options_years: [
      {id: 1,text: "2015"},
      {id: 2,text: "2016"},
      {id: 3,text: "2017"},
      {id: 4,text: "2018"},
      {id: 5,text: "2019"},
      {id: 6,text: "2020"},
      {id: 7,text: "2021"},
      {id: 8,text: "2022"},
      {id: 9,text: "2023"},
      {id: 10,text: "2024"},
      {id: 11,text: "2025"},
    ],
    options_doc_basic_kind: [
      {id: 1, text:"Документы образовательных программ"},
      {id: 2, text:"Документы приемной кампании"},
      {id: 3, text:"Базовые документы"},
      {id: 4, text:"Материально-техническое обеспечение"},
      {id: 5, text:"Структурные подразделения"},
      {id: 6, text:"Приказы 1С:Университет"},
    ],
    options_doc_type: [],
    options_doc_kind: [],
    options_doc_file: [],
    options_certificates: [],
    options_educational_programm: [],

    signature_checked: [],

    file: '',
    errors: [],
  }),
  mounted() {
    this.AppealTo1c('ep','get','/reference/get_educational_programm','',{}, '');
  },
  computed: {
    questionFields: function () {
      return `${this.doc_kind}${this.doc_year}${this.doc_date_create}${this.educational_programm}`;
    },
  },
  watch: {
    'questionFields': function (newValue, oldValue){
      if(this.doc_kind != "") this.LoadFile()
    },
    /*checked: function (newValue, oldValue){
      if(newValue){
        this.signature_checked = this.options_doc_file.filter((file)=>{return file.url != ''});
      }else{
        this.signature_checked = [];
      }
    },*/
    signature_checked: function (newValue, oldValue){
      console.log(newValue)
      if(this.signature_checked.length == this.conte_enable_file){
        this.checked = true;
      }else{
        this.checked = false;
      }
    }
  },
  methods: {
    SetEducationalProgramm: function (value){
      this.educational_programm = value;
    },
    ClearDocYear: function (){
       $('#doc_year').dropdown('clear');
      this.doc_year = "";
    },
    ClearEducationalProgramm: function (){
      this.educational_programm = "";
      $('#default_educational_programm').html("");
    },
    ClearDocDateCreate: function (){
      this.doc_date_create = "";
    },
    SetAllChecked: function (){
      if(this.checked){
        this.signature_checked = this.options_doc_file.filter((file)=>{return file.url != '' && file.url_sig == ""});
      }else{
        this.signature_checked = [];
      }
    },
    LoadDocType: function(){
      this.doc_type = ""
      $('#doc_type').dropdown('restore defaults');
      this.progress_bar_flag = true;
      $('#progress_bar').progress('reset');
      $('#progress_bar').progress({percent: 20});
      this.AppealTo1c("type",'get',"/reference/get_type_doc",`?doc_basic_kind=${this.doc_basic_kind}`,{}, "");
      this.ListSignature().then((signature)=>{
             this.options_certificates = signature;
           },(error) => {
              console.log(error);
           });
    },
    LoadDocKind: function(){
      this.doc_kind = ""
      this.progress_bar_flag = true;
      $('#doc_kind').dropdown('restore defaults');
      $('#progress_bar').progress('reset');
      $('#progress_bar').progress({percent: 20});
      this.AppealTo1c("kind",'get',"/reference/get_kind_doc",`?doc_basic_kind=${this.doc_basic_kind}&doc_type=${this.doc_type}`,{}, "")
    },
    LoadFile: function(){
      this.progress_bar_flag = true;
      $('#progress_bar').progress('reset');
      $('#progress_bar').progress({percent: 20});
      this.AppealTo1c("file",'get',"/reference/get_file_doc",`?doc_basic_kind=${this.doc_basic_kind}&doc_type=${this.doc_type}&doc_kind=${this.doc_kind}&doc_year=${this.doc_year}&doc_date_create=${this.doc_date_create}&id_educational_programm=${this.educational_programm}`,{}, "")
    },
    ListSignature: function () {
      return new Promise((resolve, reject) => {
        cadesplugin.async_spawn(function *() {
          var certs;
          var certCnt;
          var certificates = [];
          var MyStoreExists = true;

          try{
            var oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
            if (!oStore) {
              console.log("Не удалось создать store")
              return;
            }
            yield oStore.Open();
          }catch (ex) {
            MyStoreExists = false;
          }

          try {
            yield oStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
            certs = yield oStore.Certificates;
            certCnt = yield certs.Count;

            for (var i = 1; i <= certCnt; i++) {
              var cert = yield certs.Item(i);
              // yield cert.SubjectName.then((name)=>{console.log(name)});
              // yield cert.Thumbprint.then((name)=>{console.log(name)});

              let sub_name = yield cert.SubjectName;
              let date = yield cert.ValidFromDate;
              yield cert.Thumbprint.then((name)=>{
                if(certificates.filter((certificate)=>{(certificate.thumb_print) === name}).length == 0){
                  certificates.push({id: i, sub_name: sub_name, thumb_print: name, date: date})
                }
              });
              //resolve(certificates);
            }
            yield oStore.Close();
            resolve(certificates);
          }
          catch (ex) {
          }
        });
      });
    },
    SetSignature: function(){
      if(!this.certificate){
        this.error_message_flag = true;
        this.error_message_text = "Не выбран сертификат";
      }else if(this.signature_checked.length == 0){
        this.error_message_flag = true;
        this.error_message_text = "Не выбран не один файл";
      }else{
        this.error_message_flag = false;
        $('#progress_bar').progress('reset');
        $('#progress_bar').progress({percent: 20});
        this.signature_checked.forEach((current_file) => {
          axios.get(current_file.url, {responseType: 'blob'}).then((response) => {
            this.CreateSignature(response.data).then((current_sig) => {
              this.AppealTo1c("sig", 'post', "/reference/create_sig_file", '', {
                doc_basic_kind: this.doc_basic_kind,
                doc_kind: this.doc_kind,
                id: current_file.id,
                type_save_file: current_file.type_save_file,
                signature: current_sig
              }, "");
            }, (error) => {
              console.log(error);
            });
          }).catch(console.error)
        });
      }
    },
    CreateSignature: function(oFile){
      return new Promise((resolve, reject) => {
        var CADESCOM_CADES_BES = 1;
        var CAPICOM_CURRENT_USER_STORE = 2;
        var CAPICOM_MY_STORE = "My";
        var CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED = 2;
        var CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME = 1;
        var CADESCOM_BASE64_TO_BINARY = 1;
        var sSignedMessage;
        var sub_name_certificate = this.options_certificates.filter((op) => {return op.thumb_print == this.certificate })[0].sub_name
        var currentCN = sub_name_certificate.match(/CN=[А-Яа-яA-Za-z_" ]*/)[0].replace("CN=", "")  // ошибка не выбранного cn
        //console.log(currentCN)

        cadesplugin.async_spawn(function* (args) {
          // Проверяем, работает ли File API
          if(!window.FileReader){
            console.log("Браузер не поддерживает File API КриптоПРО CSP");
            return;
          }

          if (oFile == '' || oFile == undefined || oFile == null) {
            console.log("Файл не найден");
            return;
          }

          var oFReader = new FileReader();

          if (typeof (oFReader.readAsDataURL) != "function") {
            console.log("Метод readAsDataURL() не поддерживается в FileReader");
            return;
          }

          oFReader.readAsDataURL(oFile);

          oFReader.onload = function (oFREvent) {
            cadesplugin.async_spawn(function* (args) {
              var header = ";base64,";
              var sFileData = oFREvent.target.result;
              var sBase64Data = sFileData.substr(sFileData.indexOf(header) + header.length);

              //добавить поле, где нужно выбирать сертификат
              //var oCertName = document.getElementById("CertName");
              //var sCertName = oCertName.value; // Здесь следует заполнить SubjectName сертификата
              //var sCertName = "amursu_test"
              var sCertName = currentCN;
              if ("" == sCertName) {
                console.log("Укажите имя сертификата cn=''");
                return;
              }
              var oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
              yield oStore.Open(CAPICOM_CURRENT_USER_STORE, CAPICOM_MY_STORE,
                  CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED);

              var oStoreCerts = yield oStore.Certificates;
              var oCertificates = yield oStoreCerts.Find(
                  CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME, sCertName);
              var certsCount = yield oCertificates.Count;
              if (certsCount === 0) {
                console.log("Сертификат не найден: " + sCertName);
                return;
              }
              var oCertificate = yield oCertificates.Item(1);
              var oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
              yield oSigner.propset_Certificate(oCertificate);
              yield oSigner.propset_CheckCertificate(true);

              var oSignedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");
              yield oSignedData.propset_ContentEncoding(CADESCOM_BASE64_TO_BINARY);
              yield oSignedData.propset_Content(sBase64Data);

              try {
                sSignedMessage = yield oSignedData.SignCades(oSigner, CADESCOM_CADES_BES, true);
              } catch (err) {
                console.log("Создание подписи окончилось не удачей. Ошибка: " + cadesplugin.getLastError(err));
                return;
              }

              yield oStore.Close();

              //resolve(sSignedMessage);
              // Выводим отделенную подпись в BASE64 на страницу
              // Такая подпись должна проверяться в КриптоАРМ и cryptcp.exe
              var oSignedData2 = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");

              try {
                yield oSignedData2.propset_ContentEncoding(CADESCOM_BASE64_TO_BINARY);
                yield oSignedData2.propset_Content(sBase64Data);
                yield oSignedData2.VerifyCades(sSignedMessage, CADESCOM_CADES_BES, true);
                console.log("Подпись проверена");
              } catch (err) {
                console.log("Создание подписи окончилось не удачей. Ошибка: " + cadesplugin.getLastError(err));
                return;
              }
               resolve(sSignedMessage);
            });
          };
        });
      });
    },
    DeleteSignature: function(type_destroy){
     if(this.signature_checked.length == 0){
        this.error_message_flag = true;
        this.error_message_text = "Не выбран не один файл";
      }else {
        this.error_message_flag = false;
        $('#progress_bar').progress('reset');
        $('#progress_bar').progress({percent: 20});
        this.signature_checked.forEach((current_file) => {
          this.AppealTo1c("des", 'get', "/reference/destroy_sig", `?doc_basic_kind=${this.doc_basic_kind}&type_destroy=${type_destroy}&id=${current_file.id}&url=${current_file.url}&type_save_file=${current_file.type}`, {}, "");
        });
      }
    },
    CheckSignature: function(){
      if(!this.certificate){
        this.error_message_flag = true;
        this.error_message_text = "Не выбран сертификат";
      }else if(this.signature_checked.length == 0){
        this.error_message_flag = true;
        this.error_message_text = "Не выбран не один файл";
      }else{
        this.error_message_flag = false;
      }
    },
    RespondService: function(response_data,){
      let current_doc_file = _.find(this.options_doc_file, { id: +response_data.id })
      current_doc_file.status = response_data.status
      current_doc_file.url_sig = (response_data.url_sig ? this.url.origin + response_data.url_sig : "")
      if(response_data.status == "positive"){ this.signature_checked.splice(_.findIndex(this.signature_checked,{ id: +response_data.id }),1) }
    },
    AppealTo1c: function(type, method,path,params,data,message){
      $('#progress_bar').progress({percent: 50});
      const token = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;

      axios({
        method: method,
        url: `${path}${params}`,
        data: data,
      }).then((response) => {
        $('#progress_bar').progress({percent: 80})

        if(type == "type"){
          this.options_doc_type = response.data;
        }else if(type == "kind"){
          this.options_doc_kind = response.data;
        }else if(type == "file"){
          this.options_doc_file = response.data;
          this.conte_enable_file = this.options_doc_file.length - this.options_doc_file.filter((file)=>{return file.url == ''}).length
        }else if(type == "sig"){
          this.RespondService(response.data);
        }else if(type == "des"){
          if(response.data.type_destroy == "sig"){
            this.RespondService(response.data);
          }else if(response.data.type_destroy == "object"){
            if(response.data.status == "positive"){
              this.options_doc_file.splice(_.findIndex(this.options_doc_file,{ id: +response.data.id }),1);
              this.signature_checked.splice(_.findIndex(this.signature_checked,{ id: +response.data.id }),1);
            }
          }
        }else if(type == "ep"){
          this.options_educational_programm = response.data;
        }

        $('#progress_bar').progress({percent: 100})
        return response;
      }).catch((error) => {
        return error;
      });
    },

  },
}
</script>

<style>
.disabled_text{
  color: rgba(0,0,0,.25);
  pointer-events: none;
}
</style>